import { render } from "./Dashboard6.vue?vue&type=template&id=99d3a380"
import script from "./Dashboard6.vue?vue&type=script&lang=js"
export * from "./Dashboard6.vue?vue&type=script&lang=js"

import "./Dashboard6.vue?vue&type=style&index=0&id=99d3a380&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__